import { baseUrl } from "../../../baseurl";
import { create } from "zustand";
import axios from "axios";
import { notification } from 'antd';

export const useAdvertise = create((set, get) => ({
  Advertise: [],
  AdvertiseIMG: [],
  idMaster: "",
  calendar: [],
  isSuccessEdit: false,
  isSuccessEditMaster: false,
  isSuccessEditCalendarBulkInsert: null,

  actions: {
    editAdsDetailForDailyPrices: async (id, adsMasterCode, adsPrptyCategoryCode, adsPrptyTradeTypeCode, adsPrptyTypeCode,
      adsAdvertiseTypeCode, pricePerMeter, totalPrice, propertyLandMetarage, propertyWidth, deposit,
      squareFootageEntireProperty, rentPerMonth, abilityToConvert, convertingDepositAmount,
      convertingRentAmount, meterage, numberOfRooms, lifeOfTheBuilding, dateForRent, floorNumber,
      totalFloor, unitPerFloor, parking, basement, elevator, description, standardCapacity, maxAddPeople, pricePerAddPeople) => {
      await axios.patch(`${baseUrl}/Advertise/EditAdsDetail`, {
        "id": id,
        "adsMasterCode": adsMasterCode,
        "adsPrptyCategoryCode": adsPrptyCategoryCode,
        "adsPrptyTradeTypeCode": adsPrptyTradeTypeCode,
        "adsPrptyTypeCode": adsPrptyTypeCode,
        "adsAdvertiseTypeCode": adsAdvertiseTypeCode,
        "pricePerMeter": pricePerMeter,
        "totalPrice": totalPrice,
        "propertyLandMetarage": propertyLandMetarage,
        "propertyWidth": propertyWidth,
        "deposit": deposit,
        "squareFootageEntireProperty": squareFootageEntireProperty,
        "rentPerMonth": rentPerMonth,
        "abilityToConvert": abilityToConvert,
        "convertingDepositAmount": convertingDepositAmount,
        "convertingRentAmount": convertingRentAmount,
        "meterage": meterage,
        "numberOfRooms": numberOfRooms,
        "lifeOfTheBuilding": lifeOfTheBuilding,
        "dateForRent": dateForRent,
        "floorNumber": floorNumber,
        "totalFloor": totalFloor,
        "unitPerFloor": unitPerFloor,
        "parking": parking,
        "basement": basement,
        "elevator": elevator,
        "description": description,
        "standardCapacity": standardCapacity,
        "maxAddPeople": maxAddPeople,
        "pricePerAddPeople": pricePerAddPeople
      }, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
        },
      })
        .then(res => {

          localStorage.setItem("idDetail", res.data.id);
          if (res.status == 200) {

            set((state) => ({ isSuccessEdit: true }));
          } else {

            set((state) => ({ isSuccessEdit: false }));
          }
        })
        .catch((error) => {
          console.error("Error fetching Advertise:", error);
          set((state) => ({ isSuccessEdit: false }));
        });
    },
    editCalendarBulkInsert: async (adS_Prpty_Details_Code, calendarBulkItem) => {
      await axios.post(`${baseUrl}/Advertise/EditCalendarBulkInsert`, {
        "adS_Prpty_Details_Code": adS_Prpty_Details_Code,
        "calendarBulkItem": [
          calendarBulkItem
        ]
      }, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
        },
      })
        .then((res) => {
          set((state) => ({ isSuccessEditCalendarBulkInsert: true }));
        })
        .catch(() => {
          set((state) => ({ isSuccessEditCalendarBulkInsert: false }));
        });
    },

    postAllAdvertise: async ({
      id,
      UsruserCode,
      AdsMainCategoryCode,
      adsAdvertiseShowTypeCode,
      countryCode,
      StateCode,
      CityCode,
      AreaCode,
      Latitude,
      Longitude,
      isApproximateArea,
      AdsTitle,
      address,
      ownerName,
      MobilePhone,
      LandPhone,
      Price,
      Description,
      isBlockCommnet,
      isActiveChat,
      isShowMobile,
    }) => {
      await axios
        .patch(`${baseUrl}/Advertise/EditAdsMaster`, {
          id:
            localStorage.getItem("idMasterEdit") != -1
              ? localStorage.getItem("idMasterEdit")
              : id,
          usruserCode: UsruserCode,
          adsMainCategoryCode: AdsMainCategoryCode,
          adsAdvertiseShowTypeCode: adsAdvertiseShowTypeCode,
          countryCode: countryCode,
          stateCode: StateCode,
          cityCode: CityCode,
          areaCode: AreaCode,
          latitude: Latitude,
          longitude: Longitude,
          isApproximateArea: isApproximateArea,
          adsTitle: AdsTitle,
          address: address,
          ownerName: ownerName,
          mobilePhone: MobilePhone,
          landPhone: LandPhone,
          price: Price,
          description: Description,
          isBlockCommnet: isBlockCommnet,
          isActiveChat: isActiveChat,
          isShowMobile: isShowMobile,
        }, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
          },
        })
        .then(async (res) => {
          await localStorage.setItem("idMaster", res.data.id);
          await localStorage.setItem("titleMaster", res.data.adsTitle);

          if (res.status == 200) {

            set((state) => ({ isSuccessEditMaster: true }));
            setTimeout(() => {
              set((state) => ({ isSuccessEditMaster: false }));
            }, 3000);
          } else {


            set((state) => ({ isSuccessEditMaster: false }));
          }
        })
        .catch((error) => {
          console.error("Error fetching Advertise:", error);
          set((state) => ({ isSuccessEditMaster: false }));
        });
    },
    postEditAdsDetail: async (id, adsMasterCode, adsPrptyCategoryCode, adsPrptyTradeTypeCode, adsPrptyTypeCode,
      adsAdvertiseTypeCode, pricePerMeter, totalPrice, propertyLandMetarage, propertyWidth, deposit,
      squareFootageEntireProperty, rentPerMonth, abilityToConvert, convertingDepositAmount,
      convertingRentAmount, meterage, numberOfRooms, lifeOfTheBuilding, dateForRent, floorNumber,
      totalFloor, unitPerFloor, parking, basement, elevator, description) => {
      await axios.patch(`${baseUrl}/Advertise/EditAdsDetail`, {
        "id": id,
        "adsMasterCode": adsMasterCode,
        "adsPrptyCategoryCode": adsPrptyCategoryCode,
        "adsPrptyTradeTypeCode": adsPrptyTradeTypeCode,
        "adsPrptyTypeCode": adsPrptyTypeCode,
        "adsAdvertiseTypeCode": adsAdvertiseTypeCode,
        "pricePerMeter": pricePerMeter,
        "totalPrice": totalPrice,
        "propertyLandMetarage": propertyLandMetarage,
        "propertyWidth": propertyWidth,
        "deposit": deposit,
        "squareFootageEntireProperty": squareFootageEntireProperty,
        "rentPerMonth": rentPerMonth,
        "abilityToConvert": abilityToConvert,
        "convertingDepositAmount": convertingDepositAmount,
        "convertingRentAmount": convertingRentAmount,
        "meterage": meterage,
        "numberOfRooms": numberOfRooms,
        "lifeOfTheBuilding": lifeOfTheBuilding,
        "dateForRent": dateForRent,
        "floorNumber": floorNumber,
        "totalFloor": totalFloor,
        "unitPerFloor": unitPerFloor,
        "parking": parking,
        "basement": basement,
        "elevator": elevator,
        "description": description,
      }, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
        },
      })
        .then(res => {

          localStorage.setItem("idDetail", res.data.id);
          if (res.status == 200) {
            notification.success({ message: 'فایل با موفقیت ثبت شد' });


            set((state) => ({ isSuccessEdit: true }));
            setTimeout(() => {
              set((state) => ({ isSuccessEdit: false }));
            }, 3000);
          } else {
            notification.error({ message: 'خطا در ثبت آگهی' });

            set((state) => ({ isSuccessEdit: false }));
          }
        })

        .catch((error) => {
          console.error("Error fetching Advertise:", error);
          set((state) => ({ isSuccessEdit: false }));
        });
    },

    postEditAdsPrptyApplicantRentBuy: async (adsMasterCode, adsPrptyTradeTypeCode, adsPrptyTypeCode, applicantType, buyPriceFrom,
      buyPriceTo, rentDepositFrom, rentDeposintTo, rentPriceFrom, rentPriceTo, metrageFrom,
      meterageTo, lifeOfBuildingFrom, lifeOfBulidingTo, description) => {
      await axios.patch(`${baseUrl}/Advertise/EditAdsPrptyApplicantRentBuy`, {
        "adsMasterCode": adsMasterCode,
        "adsPrptyTradeTypeCode": adsPrptyTradeTypeCode,
        "adsPrptyTypeCode": adsPrptyTypeCode,
        "applicantType": applicantType,
        "buyPriceFrom": buyPriceFrom,
        "buyPriceTo": buyPriceTo,
        "rentDepositFrom": rentDepositFrom,
        "rentDeposintTo": rentDeposintTo,
        "rentPriceFrom": rentPriceFrom,
        "rentPriceTo": rentPriceTo,
        "metrageFrom": metrageFrom,
        "meterageTo": meterageTo,
        "lifeOfBuildingFrom": lifeOfBuildingFrom,
        "lifeOfBulidingTo": lifeOfBulidingTo,
        "description": description
      }, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
        },
      })
        .then(res => {

        })
        .catch((error) => {
          console.error("Error fetching Advertise:", error);
        });
    },

    postEditAdsPrptyAuction: async (tblAdsPrptyDetailsCode, possibilityInPersonVisit, customerVisitDate,
      visitTimeFrom, visitTimeTo, address) => {
      await axios.patch(`${baseUrl}/Advertise/EditAdsPrptyAuction`, {
        "tblAdsPrptyDetailsCode": tblAdsPrptyDetailsCode,
        "possibilityInPersonVisit": possibilityInPersonVisit,
        "customerVisitDate": customerVisitDate,
        "visitTimeFrom": visitTimeFrom,
        "visitTimeTo": visitTimeTo,
        "address": address
      }, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
        },
      })
        .then(res => {

          set({ Advertise: res.data });
        })
        .catch((error) => {
          console.error("Error fetching Advertise:", error);
        });
    },

    postAllAdvertiseIMG: async (tblAdsMasterCode, picUrl, pirority) => {

      await axios.post(`${baseUrl}/Advertise/EditAdsImage RegisterAD`, {
        "id": 0,
        "tblAdsMasterCode": tblAdsMasterCode,
        "picUrl": picUrl,
        "pirority": pirority
      }, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("pelakToken")}`,
          'Content-Type': 'multipart/form-data',
        }
      }
      ).then(res => {


      })
        .catch(error => {
          console.error("Error fetching Advertise:", error);
        });

    }



    ,
    saveOrderImg: async (adsMasterId, adsImage, priority) => {

      await axios.post(`${baseUrl}/Advertise/EditAdsImage`, {
        "id": 0,
        "adsMasterId": adsMasterId,
        "priority": priority,
        "adsImage": adsImage
      }, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("pelakToken")}`,
          // "x-rapidapi-host": "file-upload8.p.rapidapi.com",
          // "x-rapidapi-key": "your-rapidapi-key-here",
        },
      }
      )
        .then((res) => {

        })
    },

    saveOrderImg: async (adsMasterId, adsImage, priority) => {

      await axios
        .post(
          `${baseUrl}/Advertise/EditAdsImage`,
          {
            id: 0,
            adsMasterId: adsMasterId,
            priority: priority,
            adsImage: adsImage,
          },
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${localStorage.getItem("pelakToken")}`,
              // "x-rapidapi-host": "file-upload8.p.rapidapi.com",
              // "x-rapidapi-key": "your-rapidapi-key-here",
            },
          }
        )
        .then((res) => { });
    },

    addImageAtEdit: async (adsMasterId, adsImage, priority) => {


      try {
        const response = await axios.post(
          `${baseUrl}/Advertise/EditAdsImageV2`,
          {
            id: 0,
            tblAdsMasterCode: adsMasterId,
            picUrl: adsImage,
            priority: priority,
          },
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${localStorage.getItem("pelakToken")}`,
            },
          }
        );

      } catch (error) {
        console.error("Error in addImageAtEdit:", error);
      }
    },

    getAdsCalendar: () => {
      axios
        .get(`${baseUrl}/Advertise/GetAdsCalendar`)
        .then((res) => {
          set({ calendar: res.data });
        }, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
          },
        })
        .catch((error) => {
          console.error("Error fetching holidays:", error);
        });
    },

    addPhoneNumber: async (adsMasterId, phoneNumbers) => {


      await axios
        .post(
          `${baseUrl}/Advertise/AddPhoneNumber`,
          {

            adsMasterId: adsMasterId,
            phoneNumbers: phoneNumbers
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("pelakToken")}`,
            },
          }
        )
        .then((res) => { });
    }
  },
}));

// isApproximateArea : props.isApproximateArea,
